import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Fragment } from "react";
import { sxList } from "../../../../../components/shared/list/list.styled";
import { Colors } from "../../../../../colors";
import i18n from "../../../../../translations/strings";
import { TableEventsReservationStyled } from "./table-events-reservation.styled";


export interface TableEventsReservationProps {
    events: any;
    fields: any;
    backgroundColor?: string
}

const remoteAttendeesZoomLimit = 100

const TableEventsReservation = (props: TableEventsReservationProps) => {

    return (
      <Table sx={{ width: '100%' }} aria-label="simple table">
        <TableHead sx={sxList.tableHeader}>
          <TableRow>
            {props.fields?.map((item: any, index: any) => (
              <TableCell key={index} align="left" sx={sxList.tableHeaderText}>
                {item.displayName.toUpperCase()}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody sx={{ ...sxList.tableBody, backgroundColor: props.backgroundColor }}>
          {props.events?.map((row: any) => (
            <Fragment key={row.id}>
              <TableRow>
                {props.fields.map((item: any, index: number) => (
                  <TableCell sx={sxList.tableBodyText} key={index} align="left">
                    {item.component ? item.component(row) : row[item.name]}
                  </TableCell>
                ))}
              </TableRow>
              {row.remote_attendees > remoteAttendeesZoomLimit && (
                <TableRow sx={{ backgroundColor: Colors.Unselected }}>
                  <TableCell
                    sx={{ paddingTop: '7.5px', paddingBottom: '7.5px' }}
                    colSpan={12}
                  >
                    <TableEventsReservationStyled.AttendeesLimitBreakmessage>
                      {i18n.t('eventsList.remoteAttendeesZoomLimitMessage')}
                    </TableEventsReservationStyled.AttendeesLimitBreakmessage>
                  </TableCell>
                </TableRow>
              )}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    );
}

export default TableEventsReservation;
